import ResizeObserver from 'resize-observer-polyfill';

import { DEFAULT_PATH_EMBEDDED } from '../BuildConstants';
import { Utilities } from './Utilities';

export const setupDOMandPolyfills = (settings): void => {
  const readonly = Utilities.extraOption('data-menuid');

  if (!readonly && process.env.REACT_APP_ENVIRONMENT !== 'test') {
    try {
      // Create a single ResizeObserver instance to handle all
      // container elements. The instance is created with a callback,
      // which is invoked as soon as an element is observed as well
      // as any time that element's size changes.
      const ro = new ResizeObserver((entries) => {
        const defaultBreakpoints = { XS: 384, SM: 768, MD: 992, LG: 1200 };

        entries.forEach((entry) => {
          // If breakpoints are defined on the observed element,
          // use them. Otherwise use the defaults.
          const breakpoints = (entry.target as any).dataset.breakpoints
            ? JSON.parse((entry.target as any).dataset.breakpoints)
            : defaultBreakpoints;

          // Update the matching breakpoints on the observed element.
          Object.keys(breakpoints).forEach((breakpoint) => {
            const minWidth = breakpoints[breakpoint];
            if (entry.contentRect.width >= minWidth) {
              entry.target.classList.add(breakpoint);
            } else {
              entry.target.classList.remove(breakpoint);
            }
          });
        });
      });

      ro.observe(Utilities.flipdiv);
    } catch (error) {}
  }

  // For safari 12.2 iframe for the cookies
  const isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent;

  if (isSafari) {
    const iframe = document.createElement('iframe');
    iframe.style.height = '1px';
    iframe.style.width = '1px';
    iframe.style.border = '0';
    iframe.style.position = 'absolute';
    iframe.src = DEFAULT_PATH_EMBEDDED;
    document.body.appendChild(iframe);
  }

  // http://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
  // Add an event listener to force mobile safari to  set the :active class on elements
  // so that we can see buttons being depressed when we click on them.
  document.addEventListener('touchstart', () => {}, false);

  // For iOS bg color on bounce
  if (settings.theme === 'dark') {
    document.body.style.backgroundColor = '#414142';
  }

  /**
   * Web Order by default replaces all content
   * in the <body> with the ordering system
   * to reduce conflicts, improve speed and
   * reduce chances of customers to
   * leave the ordering system.
   * Only on mobile.
   */
  if (
    (Utilities.isIOS || Utilities.isAndroid) &&
    settings.fullScreenOnMobile !== 'false' &&
    Utilities.flipdiv
  ) {
    document.body.innerHTML = '';
    document.body.style.backgroundImage = 'none';
    if (Utilities.flipdiv) {
      document.body.appendChild(Utilities.flipdiv);
    }
  }

  if (readonly) {
    return;
  }

  const viewportMetaExists = document.querySelector("meta[name='viewport']");

  if (!viewportMetaExists) {
    const viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    viewportMeta.content =
      'width=device-width,initial-scale=1,shrink-to-fit=no';
    document.head.appendChild(viewportMeta);
  }
};
